import { Injectable, Provider } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Observable, EMPTY } from 'rxjs';
import { finalize, share } from 'rxjs/operators';

@Injectable()
export class DuplicateRequestInterceptor implements HttpInterceptor {
  private activeRequests = new Map<string, Observable<HttpEvent<any>>>();

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Only apply to POST requests
    if (req.method !== 'POST') {
      return next.handle(req);
    }

    const requestKey = this.generateRequestKey(req);

    // Check if there's already an active request for this key
    const activeRequest = this.activeRequests.get(requestKey);
    if (activeRequest) {
      return EMPTY; // Ignore the duplicate request (exhaustMap behavior)
    }

    // Create a new request observable
    const request$ = next.handle(req).pipe(
      share(), // Share the observable among multiple subscribers
      finalize(() => {
        // Clean up when the request completes
        this.activeRequests.delete(requestKey);
      }),
    );

    // Store the active request
    this.activeRequests.set(requestKey, request$);

    return request$;
  }

  private generateRequestKey(req: HttpRequest<any>): string {
    const bodyString = req.body ? JSON.stringify(req.body) : '';
    return `${req.method}:${req.url}:${bodyString}`;
  }
}

export const ExhaustMapRequestInterceptorProvider: Provider = {
  provide: HTTP_INTERCEPTORS,
  useClass: DuplicateRequestInterceptor,
  multi: true,
};
